module.exports = __webpack_public_path__ + "static/img/loading.322a00dc.gif";